import * as moment from 'moment';

export default class Util {
    static isMobile() {
        return ((cssua.ua.mobile && navigator.userAgent.toLowerCase().indexOf('mobile') !== -1) ||
            navigator.userAgent.indexOf('OS33 for iOS') !== -1 ||
            navigator.userAgent.indexOf('OS33 for Android') !== -1 ||
            navigator.userAgent.indexOf('workplace_ android') !== -1 ||
            navigator.userAgent.indexOf('workplace_ ios') !== -1 ||
            navigator.userAgent.indexOf('workplace_android') !== -1 ||
            navigator.userAgent.indexOf('workplace_ios') !== -1)
            &&
            (window.innerWidth < 737 );
    };

    static isNativeClient() {
        return navigator.userAgent.indexOf('workplace_windows') !== -1 || navigator.userAgent.indexOf('workplace_mac') !== -1;
    };

    static isTablet() {
        return ((!!cssua.ua.mobile) && window.innerWidth >= 737);
    }

    static getUrlParameter(name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)', 'i').exec(location.search) || [, ''])[1].replace(/\+/g, '%20')) || null;
    };

    static getUrlParameterByName(parameter, staticURL, decode) {
        const currLocation = (staticURL.length) ? staticURL : window.location.search;
        const parts = currLocation.split('?');
        if (parts.length < 2) {
            return false;
        }
        const parArr = parts[1].split('&');
        let returnBool = true;

        for (let i = 0; i < parArr.length; i++) {
            const parr = parArr[i].split('=');
            if (parr[0] === parameter && parr[1] && parr[1].length) {
                return (decode) ? decodeURIComponent(parr[1]) : parr[1];
            } else {
                returnBool = false;
            }
        }
        /* istanbul ignore else */
        if (!returnBool) {
            return false;
        }
    };

    static buildBackUrl(fromUrl) {
        if (fromUrl) {
            return fromUrl;
        }

        return '/';
    }

    static limitNameLength(input, totalLength, lastCharactersLength) {
        const name = input ? input : '';
        const nameLength = name.length;
        if (nameLength > totalLength) {
            const lastPart = name.slice(nameLength - lastCharactersLength, nameLength);
            const firstPart = name.slice(0, totalLength - lastCharactersLength - 3);
            return firstPart + '…' + lastPart;
        } else {
            return name;
        }
    }

    static locationCityStateCountry(location, ip) {
        let clientLocation = '';
        if (location === null) {
            clientLocation = ip;
        } else {
            const city = location.city ? location.city + ', ' : '';
            const state = location.state ? location.state + ', ' : '';
            const country = location.country ? location.country : '';
            clientLocation = city + state + country;
        }
        return clientLocation;
    }

    static timeAgo(date) {
        return moment(date).fromNow();
    }

    static caseInsensitiveStringCompare(a, b) {
        return a.toLowerCase() === b.toLowerCase();
    }

    static getStaticResourceUrl(url) {
        let baseUrl = process.env.basename;
        return baseUrl ? baseUrl + url : url;
    }

    static getErrorMessage(error) {
        if (!error) {
            return "";
        }
        if (typeof error === "string") {
            return error;
        }
        if (error.message) {
            return error.message;
        }
        return "";
    }

    static sendMessage(message) {
        try {
            if (window.chrome && window.chrome.webview) {
                window.chrome.webview.postMessage(message);
            } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.jsMessageHandler) {
                window.webkit.messageHandlers.jsMessageHandler.postMessage(message);
            }
        }
        catch (e) {
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/services/util.js